// JS imports
import $ from 'jquery';
import Vue from 'vue';
import VueBgSrc from 'vue-bg-src';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueSlideToggle from 'vue-slide-toggle';
import VueShave from 'vue-shave';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import './svgs';
import { RestComponent } from './mixins/rest-component';
import EventBus from './eventBus';
import FixedHeader from 'vue-fixed-header';
import AOS from 'aos';
import vueKeepScroll from 'vue-keep-scroll';

//<--plop-vue-components-->//
import './GiLogo';
import './MobileMenu';
import './HeroHeading';
import './GiSearch';
import './EventsFilter';
import './EventsOverview';
import './LoadSpinner';
import './NewsGrid';
import './FeaturedNews';

import './NewsFilter';
import './NewsOverview';
import './Animations';
import './Accordion';
import './YoutubeVideo';

// Initialize siteData variable on window
window.siteData = window.siteData || {};

// Add site-wide data here:
const siteData = Object.assign(window.siteData, {
	showNav: false,
	isMounted: false,
	showSearch: false,
	showLogoText: false,
	currentScroll: 0,
});

const mediaQueries = {
	md: '(min-width: 768px)',
	lg: '(min-width: 1024px)',
	xl: '(min-width: 1400px)',
};

Vue.use(VueBgSrc, { mediaQueries: mediaQueries });

Vue.use(VueYouTubeEmbed);
Vue.use(VueSlideToggle);
Vue.use(VueShave);
Vue.use(VueMoment, {
	moment,
});

Vue.use(vueKeepScroll);

export default new Vue({
	el: '#root',
	mixins: [RestComponent],
	components: {
		FixedHeader,
	},
	data: siteData,
	computed: {
		cardHeadingHeigt() {
			const width = window.innerWidth;
			if (width < 600) {
				return 115;
			} else if (width > 767 && width < 1024) {
				return 80;
			} else if (width > 1023 && width < 1400) {
				return 140;
			} else if (width > 1400) {
				return 240;
			} else {
				return 180;
			}
		},
	},
	watch: {},
	methods: {
		scrollToForm() {
			let scrollOffset = 100;
			if (window.innerWidth < 600) {
				scrollOffset = 30;
			}
			$('html, body').animate(
				{
					scrollTop: $('#form').offset().top - scrollOffset,
					easing: 'swing',
				},
				500
			);
		},
		toggleSearch() {
			siteData.showSearch = true;
		},
		toggleMenuCloseSearch() {
			if (!siteData.showNav && !siteData.showSearch) {
				siteData.showNav = true;
			} else {
				siteData.showNav = false;
				siteData.showSearch = false;
			}
		},
	},
	mounted() {
		EventBus.$on('close-search', () => {
			this.toggleMenuCloseSearch();
			window.scrollTo(0, siteData.currentScroll);
		});
		EventBus.$on('current-scrollpos', pos => {
			siteData.currentScroll = pos;
			console.log(siteData.currentScroll);
		});
	},
	created() {
		AOS.init({
			once: true,
			easing: 'ease-out-quart',
			duration: 300,
		});
	},
});
